import { ValidatorTypeDescription } from './formHelperAdditionalData';

export function getErrorMessage(validatorType: ValidatorTypeDescription, propertyName: string, restriction: (string | number | null) = null) {
    let lowerCasePropertyName = propertyName.toLowerCase();

    switch (validatorType) {
        case ValidatorTypeDescription.Required:
            return `Please provide ${lowerCasePropertyName}`;
        case ValidatorTypeDescription.Regexp:
            return `Please provide a valid ${lowerCasePropertyName}`;
        case ValidatorTypeDescription.Min:
            return `${lowerCasePropertyName} should be at least ${restriction}`;
        case ValidatorTypeDescription.Max:
            return `${lowerCasePropertyName} can't be more than ${restriction}`;
        case ValidatorTypeDescription.MinLength:
            return `${lowerCasePropertyName} must contain a minimum of ${restriction} characters`;
        case ValidatorTypeDescription.MaxLength:
            return `${lowerCasePropertyName} can't contain more then ${restriction} characters`;
        default:
            return 'Invalid value.';
    }
}